import styled from 'styled-components';

const ReactTagsBootstraped = styled.div`
  .ReactTags__tags {
    position: relative;
  }

  /* Styles for the input */
  .ReactTags__tagInput {
    width: 200px;
    display: inline-block;
  }
  .ReactTags__tagInput input.ReactTags__tagInputField,
  .ReactTags__tagInput input.ReactTags__tagInputField:focus {
    display: block;
    width: 100%;
    /* height: calc(((1rem * 1.5) + (0.375rem * 2)) + (1px * 2)); */
    height: calc(2.25rem + 2px);
    padding: 0.375rem 0.75rem;
    margin: 0.25rem 0.25rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  /* Styles for selected tags */
  .ReactTags__selected {
    display: block;
  }

  .ReactTags__tag {
    display: inline-block;
    padding: 0.25em 0.4em;
    /* font-size: 75%; */
    font-weight: 700;
    line-height: 1;
    margin: 0.25rem 0.25rem;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    /* Secondary color badge */
    color: #fff;
    background-color: #17a2b8;

    /* Empty badges collapse automatically */
    &:empty {
      display: none;
    }
  }

  svg.ReactTags__remove {
    color: #fff;
    margin-left: 5px;
    cursor: pointer;
  }

  /* Styles for suggestions */
  .ReactTags__suggestions {
    position: absolute;
  }
  .ReactTags__suggestions ul {
    /* list-group bootstrap class */
    display: flex;
    flex-direction: column;
    /* No need to set list-style: none; since .list-group-item is block level */
    padding-left: 0; /* reset padding because ul and ol */
    margin-bottom: 0;
  }
  .ReactTags__suggestions li {
    /* list-group-item bootstrap class */
    position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    /* Place the border on the list items and negative margin up for better styling */
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);

    /* list-group-item-action bootstrap class */
    width: 100%; /* For button  (anchors become 100% by default though) */
    color: #495057;
    text-align: inherit; /* For button (anchors inherit) */

    &:first-child {
      border-top-left-radius: 0.25rem;
      border-top-right-radius: 0.25rem;
    }

    &:last-child {
      margin-bottom: 0;
      border-bottom-right-radius: 0.25rem;
      border-bottom-left-radius: 0.25rem;
    }

    &:hover,
    &:focus {
      /* list-group-item */
      z-index: 1; /* Place hover/active items above their siblings for proper border styling */
      text-decoration: none;
      /* list-group-item-action */
      color: #495057;
      text-decoration: none;
      background-color: #f8f9fa;
    }

    &.disabled,
    &:disabled {
      color: #6c757d;
      background-color: #fff;
    }
  }

  .ReactTags__suggestions li mark {
    color: #495057;
    text-decoration: underline;
    background: none;
    font-weight: 600;
  }
  .ReactTags__suggestions ul li.ReactTags__activeSuggestion {
    /* list-group-item bootstrap class */
    z-index: 2; /* Place active items above their siblings for proper border styling */
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
    cursor: pointer;
  }
`;

export default {
  ReactTagsBootstraped
};
